import React from "react";
import { GKLayoutShell } from "@granular/gds-ux-components";

import Loading from "./Loading";
import { useFabricFeatureFlagsStatus } from "../next/hooks";
import { ChildrenProp } from "../types";

const FabricFeatureFlags: React.FC<ChildrenProp> = ({ children }) => {
  React.useEffect(() => {
    console.debug("[@granular/fabric-core][FabricFeatureFlags] mounted");
  }, []);

  // Use fabric feature flags but not
  // for the current user or the current operation
  // (since those won't be known until Login.tsx & CurrentOperation.tsx)
  const fabricFlagsStatus = useFabricFeatureFlagsStatus({
    ignoreUserId: true,
    ignoreOperationId: true,
  });

  const isReady = fabricFlagsStatus === "success";

  if (!isReady) {
    console.debug("[@granular/fabric-core][FabricFeatureFlags] Loading", {
      fabricFlagsStatus,
    });
    return (
      // Because this is rendering some UI, we need GKLayoutShell
      <GKLayoutShell>
        <Loading />
      </GKLayoutShell>
    );
  }

  return <>{children}</>;
};

export default FabricFeatureFlags;
